import { useCallback, useEffect } from "react";
import { history as navigator } from "../components/App/useAppHistory";

const useBlocker = (blocker, shouldPrompt) => {
  useEffect(() => {
    if (!shouldPrompt) return

    const unblock = navigator.block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock()
          tx.retry()
        },
      }

      blocker(autoUnblockingTx)
    })

    return unblock
  }, [blocker, shouldPrompt])

  useEffect(() => {
    if (!shouldPrompt) return

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; 
      return "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldPrompt]);
};

const usePrompt = (message, shouldPrompt) => {
  const blocker = useCallback(tx => {
    if (window.confirm(message)) {
      tx.retry();
    }
  }, [message]);

  useBlocker(blocker, shouldPrompt);

};

export default usePrompt;
